const DESKTOP = 'desktop';
const TABLET = 'tablet';
const PHONE = 'phone';

export default {
    data() {
        return {
            screenType: PHONE,
            screenHeight: null
        }
    },
    mounted() {
        const setScreenType = () => {
            const width = window.innerWidth;
            if (width < 1024) {
                this.screenType = PHONE
            } else if (width < 1400) {
                this.screenType = TABLET
            } else {
                this.screenType = DESKTOP
            }
            this.screenHeight = window.innerHeight
        }
        setScreenType()
        window.addEventListener('resize', function (event) {
            setScreenType()
        })
    },
    methods: {
        isDesktop() {
            return this.screenType === DESKTOP
        },
        isTablet() {
            return this.screenType === TABLET
        },
        isPhone() {
            return this.screenType === PHONE
        }
    }
}
